/*
 * (c) Copyright, 2008-2015 Massachusetts Institute of Technology.
 *
 *     This material may be reproduced by or for the
 *     U.S. Government pursuant to the copyright license
 *     under the clause at DFARS 252.227-7013 (June, 1995).
 */
define(["ext"], function(Ext) {
    "use strict";

    return {

        buildMenuButton: function(id, icon, tooltip, enableToggle, toggleGroup, callback) {
            return Ext.create("Ext.Button", {
                enableToggle: enableToggle,
                toggleGroup: toggleGroup,
                //icon:icon,
                text: icon,
                scale: "medium",
                tooltip: tooltip,
                listeners: {
                    click: {
                        fn: function(btn) {
                            callback.fn.apply(callback.scope, btn);
                        },
                        scope: this
                    }
                }
            });
        },

        buildComboBox: function(displayField, fieldLabel, width, storeConfig, comboBoxConfig) {
            var store = Ext.create("Ext.data.Store", {
                fields: storeConfig
            });

            var config = {
                fieldLabel: fieldLabel,
                store: store,
                queryMode: "local",
                displayField: displayField,
                width: width
            };

            if (comboBoxConfig) {
                Ext.apply(config, comboBoxConfig);
            }

            return Ext.create("Ext.form.ComboBox", config);
        },
        
        buildDropdownMenu: function(label){
        	return Ext.create('Ext.Button',{
				text: label,
				baseCls: 'nontb_style',
				menu: {
					xtype: 'menu',
					autoWidth: true
				}
			});
        }
    };
});
